import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo, ValueChangedEvent } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import { RowNode } from "ag-grid-community";
import { pickersInputBaseClasses } from "@mui/x-date-pickers";

interface Props {
  Menuprops: menuInfo;
}

// 채권상세현황
const SN_SAL_COL_REP_006 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo, config } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const [pinnedRows, setPinnedRows] = useState<any[]>([]);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData({ ...rtn.formData, fg_sales: config.SAL0015.dc_ctrl });
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const searchInfo = searchRef.current.getFormdata();
      if (!searchInfo.cd_cust) {
        await showDialog("alter", "거래처를 입력하시고 조회하시기 바랍니다.");
        return;
      }
      const param = {
        id: "sn_sal_col_rep_006_01",
        params: searchRef.current.getFormdata(),
      };
      gridRefs.current["grid1"].current.resetUpdate();

      const data: any[] = (await fnGetDataSet(param))[0] || [];

      // pinned / normal 분리
      const pinned: any[] = [];
      const normal: any[] = [];

      data.forEach((row) => {
        if (row.tp === "전일이월") {
          pinned.push(row);
        } else {
          normal.push(row);
        }
      });

      setPinnedRows(pinned);
      setDataSources({ grid1: normal });
    } catch (error) {}
  };

  const recalcAfterSorting = () => {
    // 전일이월 채권잔액이 시작값
    let prevBalance = 0;
    for (const p of pinnedRows) {
      prevBalance += p.am_ar_re;
    }

    const updates: any[] = [];

    gridRefs.current["grid1"].current.forEachFilteredNode((node: any) => {
      const row = node.data;

      const ar = Number(row.am_ar || 0); // 채권액
      const col = Number(row.am_col || 0); // 수금액

      const viewBal = prevBalance + ar - col;
      prevBalance = viewBal;

      if (row.am_ar_re !== viewBal) {
        // 채권잔액
        updates.push({
          ...row,
          am_ar_re: viewBal,
        });
      }
    });

    if (updates.length > 0) {
      gridRefs.current["grid1"].current.applyTransaction({ update: updates });
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onRowDataReady: recalcAfterSorting,
          onSortChanged: recalcAfterSorting,
          onFilterChanged: recalcAfterSorting,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns}
          rowData={grids.grid1.dataSource}
          pinnedTopRowData={pinnedRows}
          etcProps={{ rowSelection: "multiple" }}
          events={grids.grid1.events}
          // qt, am으로 차트 필요
        />
      </div>
    </div>
  );
});

export default SN_SAL_COL_REP_006;
